import axios from 'axios';
import { parseJwt } from '../helpers/Helpers';
import { responsiveArray } from 'antd/es/_util/responsiveObserver';
import { Empty } from 'antd';

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
})

instance.interceptors.request.use(function (config) {
        // If token is expired, redirect user to login
    if (config.headers.Authorization) {
        const token = config.headers.Authorization.split(' ')[1]
        const data = parseJwt(token)
        if (Date.now() > data.exp * 1000) {
            window.location.href = "/"
        }
    }
    return config
}, function (error) {
    return Promise.reject(error)
})

async function sendOTP(number) {
    const response = await instance.post('/auth/sendotp', { mobileNumber: number, email: '' });
    return response;
}

async function authenticateOTP(mobileNumber,otp) {
    const response = await instance.post('/auth/authenticate', { 'mobileNumber': mobileNumber, 'otp': otp });
    return response;
}

async function authenticateMRN(mobile,mrno) {
    const response = await instance.post('/auth/authenticateMrno', { 'mobileNumber': mobile, 'mrno': mrno });
    return response;
}

async function authenticateNonPatient(patient) {
    const user = JSON.parse(localStorage.getItem('life-user'));
    const response = await instance.post('/auth/authenticateNonPatient', patient,{
        headers: {
            'Content-type': 'application/json',
            'Authorization': bearerAuth(user)
        }
    });
    return response;
}

async function loginPatient(patient) {
    const user = JSON.parse(localStorage.getItem('life-user'));
    const response = await instance.post('/auth/authenticatePatient', patient, {
        headers: {
            'Content-type': 'application/json',
            'Authorization': bearerAuth(user)
        }
    });
    return response;
}

async function get(api) {
    const user = JSON.parse(localStorage.getItem('life-user'));
    // const response = await instance.get(api, {
    //     headers: { 'Authorization': bearerAuth(user) }
    // })
    const response = await instance.post('/forward/get', { 'path': api }, {
        headers: {
            'Content-type': 'application/json',
            'Authorization': user ? bearerAuth(user) : ''
        }
    });
    return response;
}

async function getNoAuth(api) {
    const response = await instance.post('/forward/get', { 'path': api }, {
        headers: {
            'Content-type': 'application/json',
        }
    });
    return response;
}

async function getReport(api) {
    const user = JSON.parse(localStorage.getItem('life-user'));
    // const response = await instance.get(api, {
    //     headers: { 'Authorization': bearerAuth(user) }
    // })
    const response = await instance.post('/forward/getReport', { 'path': api }, {
        headers: {
            'Content-type': 'application/json',
            'Authorization': bearerAuth(user)
        },
        responseType: 'arraybuffer',
    });
    return response;
}

async function post(api, data) {
    const user = JSON.parse(localStorage.getItem('life-user'));
    const response = await instance.post('/forward/post', { 'path': api, 'body': data }, {
        headers: {
            'Content-type': 'application/json',
            'Authorization': user ? bearerAuth(user) : ''
        }
    });
    return response;
}

function bearerAuth(user) {
    return `Bearer ${user.accessToken}`
}

async function getAllReports(path,urls) {
    const user = JSON.parse(localStorage.getItem('life-user'));
    const responce = instance.post('/forward/getpdf',{path,urls}, {
        headers: {
            'Content-type': 'application/json',
            'Authorization': bearerAuth(user)
        },
        responseType: 'arraybuffer',
    });
    return responce;
}

export const Api = {
    get,
    post,
    getReport,
    sendOTP,
    authenticateOTP,
    loginPatient,
    authenticateMRN,
    authenticateNonPatient,
    getAllReports,
    getNoAuth
} 
